
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Icon_Dashboard","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"id":"Masked_Area","fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"id":"Icon_Dashboard-2","clip-path":"url(#clip-path)","transform":"translate(2081 1782)"}},[_c('path',{staticClass:"cls-4",attrs:{"id":"Rectangle_695","d":"M1.3 1.3v15.4h5.4V1.3H1.3M1 0h6a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z","transform":"translate(-2068 -1779)"}}),_c('path',{staticClass:"cls-4",attrs:{"id":"Rectangle_696","d":"M1.3 1.3v5.4h5.4V1.3H1.3M1 0h6a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z","transform":"translate(-2078 -1769)"}}),_c('path',{staticClass:"cls-4",attrs:{"id":"Rectangle_697","d":"M1.3 1.3v5.4h5.4V1.3H1.3M1 0h6a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1z","transform":"translate(-2078 -1779)"}})])])
          )
        }
      }
    